exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#dep-autres-sites>a>button.btn{font-family:Century Gothic,Times New Roman,serif;background-color:#444;color:#fff;border:0;font-weight:700;font-size:.8rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-3e2adb5a","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/Header.vue
// module id = 11
// module chunks = 0